// extracted by mini-css-extract-plugin
export default {"tableRow":"ReportRowContainer-tableRow-a1138ff00b840e768b2dc21baed5fbc5","lawBrokenCell":"ReportRowContainer-lawBrokenCell-dd1aadf400b9e55ca83fa4faac41a3a9"};